import api from '@/api/list';
import {
  getPartnerToken,
  setPartnerToken,
  removePartnerToken,
  getPartnerWechatAutoLoginFlag,
  removePartnerWechatAutoLoginCode,
  setPartnerWechatAutoLoginFlag,
  removePartnerWechatAutoLoginFlag,
  setPartnerWechatAutoLoginCode,
  getPartnerWechatAutoLoginCode,
  getUserTypeCode,
  setUserTypeCode
} from '@/utils/auth';

import {
  removeToken,
} from '@/utils/auth';

import jwt_decode from 'jwt-decode';
const partner = {
  state: {
    partnerToken: getPartnerToken(),
    partnerJwtDecode: getPartnerToken() && typeof getPartnerToken() != 'undefined' && getPartnerToken() != 'undefined' ? jwt_decode(getPartnerToken()) : {},
    userTypeCode: getUserTypeCode()
  },

  mutations: {
    SET_PARTNER_TOKEN: (state, partnerToken) => {
      state.partnerToken = partnerToken;
    },
    SET_PARTNERJWTDECODE: (state, partnerJwtDecode) => {
      state.partnerJwtDecode = partnerJwtDecode;
    },
    SET_USER_TYPE_CODE: (state, userTypeCode) => {
      state.userTypeCode = userTypeCode;
    }
  },

  actions: {
    // 账号密码登录
    partnerLogin({ commit }, userInfo) {
      commit('SET_PARTNER_TOKEN', '');
      commit('SET_PARTNERJWTDECODE', {});
      removePartnerToken();
      let parm = { username: userInfo.username, password: userInfo.password };
      return new Promise((resolve, reject) => {
        api.partnerLogin(parm, { method: 'post' })
          .then(response => {
            if (response.data.status == '200') {
              setPartnerToken(response.data.data.token);
              commit('SET_PARTNER_TOKEN', response.data.data.token);
              commit('SET_PARTNERJWTDECODE', jwt_decode(response.data.data.token));
              setUserTypeCode(response.data.data.type);
              removeToken(); //清空员工token信息
              commit('SET_TOKEN', '');
              commit('SET_JWTDECODE', {});

              //设置openid
              if (typeof getPartnerWechatAutoLoginCode() != 'undefined') { // 微信回调返回的code
                api.setPartnerOpenIdByCode({ code: getPartnerWechatAutoLoginCode() }, { method: 'patch' });
                removePartnerWechatAutoLoginCode();
              }
              resolve(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //微信自动登录
    partnerWechatAutoLogin({ commit
    }, path) {
      return new Promise((resolve, reject) => {
        let url = window.location.href;
        //是否为微信自动登录回调
        if (typeof getPartnerWechatAutoLoginFlag() == 'undefined') {
          removePartnerWechatAutoLoginCode();
          url = url.substring(0, url.indexOf("#") + 1) + path;
          let encodeUrl = encodeURIComponent(url);
          window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + process.env.VUE_APP_WXAPPID + "&redirect_uri=" + encodeUrl + "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect");
          setPartnerWechatAutoLoginFlag(1);
        } else {
          removePartnerWechatAutoLoginFlag();
          let code = url.substring(url.indexOf("code=") + 5, url.indexOf("&state=STATE"));
          if (code == "http") {
            resolve(true);
          } else {
            setPartnerWechatAutoLoginCode(code);
            api.getPartnerTokenByWechatCode({ code: code }, { method: 'post' })
              .then(response => {
                if (response.data.status == '200') {
                  if (response.data.data.token) {
                    setPartnerToken(response.data.data.token);
                    commit('SET_PARTNER_TOKEN', response.data.data.token);
                    commit('SET_PARTNERJWTDECODE', jwt_decode(response.data.data.token));
                    setUserTypeCode(response.data.data.type);
                    removeToken(); //清空员工token信息
                    commit('SET_TOKEN', '');
                    commit('SET_JWTDECODE', {});
                    resolve(response.data);
                  } else {
                    resolve(true);
                  }
                } else {
                  resolve(response.data);
                }
              })
              .catch(error => {
                reject(error);
              });
          }
        }
      });

    }

  }
};
export default partner;